import React from "react";
import { DeleteButton } from "./styles";
import { checkoutActionTypes } from "../../../../../store/modules/checkout/types";
import { useCheckoutFunction } from "../../../../../hooks/useCheckoutFunctions";
import { RiDeleteBin6Fill } from "react-icons/ri";

interface IDelete {
    productId?: string;
}

export function Delete({productId}: IDelete) {
     const { handleCheckoutActions } = useCheckoutFunction();
    return (
        <DeleteButton
              id="button-action-delete"
              onClick={() =>
                handleCheckoutActions(
                  checkoutActionTypes.REMOVE_PLU_CHECKOUT,
                  productId ? productId : '',
                  "0"
                )
              }
              title="Excluir produto"
            >
              <RiDeleteBin6Fill color="#fff" size={15} />
            </DeleteButton>
    )
}